import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  OutlinedInput,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { withSnackbar } from "../../../utils/common/SnackbarHoc";
import PreviewIcon from "@mui/icons-material/Preview";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "../../common/SettingsAccordion";
import IconUpload from "../../agent-settings/Forms/iconUpload";
import { IProductParams } from "../../../model";
import { cloneDeep } from "lodash";
import { KeyboardArrowLeft, Preview } from "@mui/icons-material";
import DOMPurify from "dompurify";

interface IProps {
  name: string;
  accordionSettings: any;
  handleAccordionSettings: (name: string) => void;
  snackbarShowMessage: any;
  chatbotSettings: any;
  setChatbotSettings: (values: any) => void;
  handleGeneralSettingsValidation: () => void;
  product: any;
}

const GeneralSettings = (props: any) => {
  const {
    accordionSettings,
    chatbotSettings,
    handleAccordionSettings,
    name,
    setChatbotSettings,
    snackbarShowMessage,
    product,
  } = props;
  const [deleteIconForChatbotFileName, setDeleteIconForChatbotFileName] =
    useState("");
  const [
    deleteIconForSendMsgIconFileName,
    setdeleteIconForSendMsgIconFileName,
  ] = useState("");
  const [
    deleteIconForBackMsgIconFileName,
    setdeleteIconForBackMsgIconFileName,
  ] = useState("");

  const handleChange = (e: any, key: string) => {
    const { value } = e.target;
    // if (productParams) {
    //   const temp: IProductParams | undefined = { ...productParams };
    //   if (
    //     temp &&
    //     temp.products &&
    //     temp.products[0] &&
    //     productParams.products[0].chatAgentSettings
    //   ) {
    //     let chatSetting = productParams.products[0].chatAgentSettings;
    //     chatSetting = { ...chatSetting, [key]: value };
    //     temp.products[0].chatAgentSettings = chatSetting;
    //     setProductParams(temp);
    //   }
    // }
    setChatbotSettings({ ...chatbotSettings, [key]: value });
  };

  const handleCheckbox = (e: any, key: string) => {
    setChatbotSettings({
      ...chatbotSettings,
      [key]: !chatbotSettings[key],
    });
  };

  const handleImageChange = (event: any, type: any) => {
    const file = event.target.files[0];
    const formUpload = new FormData();
    const size = file.size;
    const mb = 1000;
    const cur = formatFileSize(size, 2);
    if (!cur.includes("Bytes") && !cur.includes("KB")) {
      snackbarShowMessage(
        "Please upload an image with size less than 1 MB",
        "error",
        3000
      );
    } else {
      formUpload.append("file", file);
      formUpload.append("fileName", file.name);

      const reader = new FileReader();
      let dataInfo;
      reader.onload = function () {
        const [fileType, base64String] = String(reader.result).split("base64,");
        if (
          !(
            fileType.includes("png") ||
            fileType.includes("jpg") ||
            fileType.includes("jpeg")
          )
        ) {
          props.snackbarShowMessage("Unsupported image format!", "error", 3000);
          return;
        }
        let sanitizedBase64String;
        let sanitizedFile;
        if (fileType.includes("svg")) {
          const sanitizedString = DOMPurify.sanitize(atob(base64String));
          sanitizedBase64String = btoa(sanitizedString);
          sanitizedFile = new Blob([sanitizedString], {
            type: "image/svg+xml",
          });
        } else {
          sanitizedBase64String = base64String;
          sanitizedFile = file;
        }
        // const base64String = String(reader.result).split("base64,")[1];
        const extension = file.name.split(".")[1];
        dataInfo = {
          file: sanitizedBase64String,
          fileName: `${type}.${extension}`,
          deleteFileName: "",
        };
        if (type == "chatbotIcon") {
          if (
            deleteIconForChatbotFileName &&
            deleteIconForChatbotFileName != ""
          ) {
            dataInfo.deleteFileName = deleteIconForChatbotFileName;
          }
        } else if (type == "sendIcon") {
          if (
            deleteIconForSendMsgIconFileName &&
            deleteIconForSendMsgIconFileName != ""
          ) {
            dataInfo.deleteFileName = deleteIconForSendMsgIconFileName;
          }
        } else if (type == "chatIcon") {
          if (
            deleteIconForBackMsgIconFileName &&
            deleteIconForBackMsgIconFileName != ""
          ) {
            dataInfo.deleteFileName = deleteIconForBackMsgIconFileName;
          }
        }
        const resultString = URL.createObjectURL(sanitizedFile);
        handleImgChange(resultString, dataInfo, type);
      };
      reader.onerror = function (event) {
        reader.abort();
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChangeEvent = (event: any) => {
    event.target.value = null;
  };

  const deleteImage = (logo: string, type: any) => {
    // setLoading(true);
    if (product?.id != "") {
      const filenames: string[] = logo.split("/");
      const filename = filenames[filenames.length - 1];
      const dataInfo = {
        deleteFileName: filename,
      };
      if (type == "chatbotIcon") {
        setDeleteIconForChatbotFileName(filename);
      } else if (type == "sendIcon") {
        setdeleteIconForSendMsgIconFileName(filename);
      } else if (type == "chatIcon") {
        setdeleteIconForBackMsgIconFileName(filename);
      }
      handleImgChange("", dataInfo, type);
    } else {
      handleImgChange("", undefined, type);
    }
  };
  const handleImgChange = (url: string, dataInfo: any, type: any) => {
    let tempSettings = {};
    if (product?.chatAgentSettings) {
      if (type === "chatbotIcon") {
        tempSettings = { chatbotIcon: url, chatbotIconReq: dataInfo };
      } else if (type === "sendIcon") {
        tempSettings = { sendIcon: url, sendIconReq: dataInfo };
      } else if (type === "chatIcon") {
        tempSettings = { chatIcon: url, chatIconReq: dataInfo };
      }

      const newSettings = {
        ...chatbotSettings,
        ...tempSettings,
      };

      setChatbotSettings(newSettings);
    }
  };
  function formatFileSize(bytes: number, decimalPoint: number) {
    if (bytes == 0) return "0 Bytes";
    const k = 1000,
      dm = decimalPoint || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const handleAccordianChange = (value: any, type: any, clickType: any) => {
    handleAccordionSettings(type);
  };
  const [svgContent, setSvgContent] = useState<any>(null);
  const [svgsendIconContent, setsvgsendIconContent] = useState<any>(null);
  const [svgchatIconContent, setsvgchatIconContent] = useState<any>(null);

  useEffect(() => {
    const fetchSvg = async () => {
      const imgPath = chatbotSettings.chatbotIcon
        ? chatbotSettings.chatbotIcon
        : "";
      // "https://dashboard-cuvo-upload-photos.s3.amazonaws.com/product_6d414070-8396-11ee-a0ed-f3e6d67f790f/Demo1/logo.png";
      const fileExtension = getFileExtension(imgPath);
      if (fileExtension != "svg") {
        setSvgContent(
          chatbotSettings.chatbotIcon ? chatbotSettings.chatbotIcon : ""
        );
      } else {
        try {
          const response = await fetch(
            chatbotSettings.chatbotIcon ? chatbotSettings.chatbotIcon : ""
          );

          if (!response.ok) {
            throw new Error(`Failed to fetch SVG. Status: ${response.status}`);
          }
          const svgText = await response.text();
          setSvgContent(`data:image/svg+xml;base64,${btoa(svgText)}`);
        } catch (error) {
          // console.error("Error fetching SVG:", error);
        }
      }
    };

    fetchSvg();
  }, [chatbotSettings]);
  useEffect(() => {
    const fetchSendIconSvg = async () => {
      const imgPath = chatbotSettings.sendIcon ? chatbotSettings.sendIcon : "";
      const fileExtension = getFileExtension(imgPath);
      if (fileExtension != "svg") {
        setsvgsendIconContent(
          chatbotSettings.sendIcon ? chatbotSettings.sendIcon : ""
        );
      } else {
        try {
          const response = await fetch(
            chatbotSettings.sendIcon ? chatbotSettings.sendIcon : ""
          );

          if (!response.ok) {
            throw new Error(`Failed to fetch SVG. Status: ${response.status}`);
          }
          const svgText = await response.text();
          setsvgsendIconContent(`data:image/svg+xml;base64,${btoa(svgText)}`);
        } catch (error) {
          // console.error("Error fetching SVG:", error);
        }
      }
    };

    fetchSendIconSvg();
  }, [chatbotSettings]);
  useEffect(() => {
    const fetchChatIconSvg = async () => {
      const imgPath = chatbotSettings.chatIcon ? chatbotSettings.chatIcon : "";
      const fileExtension = getFileExtension(imgPath);
      if (fileExtension != "svg") {
        setsvgchatIconContent(
          chatbotSettings.chatIcon ? chatbotSettings.chatIcon : ""
        );
      } else {
        try {
          const response = await fetch(
            chatbotSettings.chatIcon ? chatbotSettings.chatIcon : ""
          );

          if (!response.ok) {
            throw new Error(`Failed to fetch SVG. Status: ${response.status}`);
          }
          const svgText = await response.text();
          setsvgchatIconContent(`data:image/svg+xml;base64,${btoa(svgText)}`);
        } catch (error) {
          // console.error("Error fetching SVG:", error);
        }
      }
    };

    fetchChatIconSvg();
  }, [chatbotSettings]);
  const getFileExtension = (url: any) => {
    const parts = url.split(".");
    if (parts.length > 1) {
      return parts[parts.length - 1];
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else {
      return null;
    }
  };
  return (
    <Accordion
      expanded={accordionSettings[name]}
      onChange={() => handleAccordionSettings(name)}
    >
      <AccordionSummary aria-controls={"panel1-content"} id={"panel1-header"}>
        <Grid container className="acc-prod-icon">
          <Grid item spacing={2} className="acc-prod-icon">
            Text Settings
          </Grid>
          <Grid item spacing={3} className="acc-prod-icon">
            <Tooltip
              title={
                <>
                  <Typography sx={{ fontSize: "12px" }}>
                    Customize bot settings :
                  </Typography>
                  <Typography sx={{ fontSize: "11px" }}>
                    Customize the icons and initial messages
                  </Typography>
                </>
              }
              placement="bottom"
            >
              <HelpIcon sx={{ mx: 1, fontSize: "20px" }} />
            </Tooltip>
          </Grid>
          <Grid item sx={{ marginLeft: 2, display: "flex" }}>
            {" "}
            <Tooltip title="Click to view the UI preview" placement="bottom">
              <Preview />
            </Tooltip>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <FormControl
              className="custom-select guideTourproductName"
              fullWidth
            >
              <InputLabel>
                Chatbot name
                <div style={{ display: "inline-block", color: "red" }}>*</div>
              </InputLabel>

              <OutlinedInput
                type="text"
                id="product-select"
                label="Chatbot name"
                name="chatbotName"
                value={chatbotSettings.name}
                onChange={(e) => handleChange(e, "name")}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Welcome message when opening the chatbot
                <div style={{ display: "inline-block", color: "red" }}>*</div>
              </InputLabel>
              <OutlinedInput
                type="text"
                value={chatbotSettings.welcomeMsg}
                onChange={(e) => handleChange(e, "welcomeMsg")}
                id="title-input"
                label="title"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select queryFeedback" fullWidth>
              <InputLabel htmlFor="query-feedback">
                Response query to ask feedback for message
              </InputLabel>
              <OutlinedInput
                type="text"
                value={chatbotSettings.queryFeedback || ""}
                onChange={(e) => handleChange(e, "queryFeedback")}
                id="query-feedback"
                label="queryFeedback"
                name="queryFeedback"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Response to be displayed for positive feedback
              </InputLabel>
              <OutlinedInput
                type="text"
                value={chatbotSettings.positiveFeedbackMsg || ""}
                onChange={(e) => handleChange(e, "positiveFeedbackMsg")}
                id="positiveFeedbackMsg"
                label="positiveFeedbackMsg"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Response to be displayed for negative feedback
              </InputLabel>
              <OutlinedInput
                type="text"
                value={chatbotSettings.negativeFeedbackMsg || ""}
                onChange={(e) => handleChange(e, "negativeFeedbackMsg")}
                id="negativeFeedbackMsg"
                label="negativeFeedbackMsg"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>Response message for session end</InputLabel>
              <OutlinedInput
                type="text"
                value={chatbotSettings.sessionEndMsg || ""}
                onChange={(e) => handleChange(e, "sessionEndMsg")}
                id="sessionEndMsg"
                label="sessionEndMsg"
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Switch
                  onChange={(e) => handleCheckbox(e, "omsEnabled")}
                  checked={chatbotSettings.omsEnabled ? true : false}
                  color="primary"
                />
              }
              label="Enable OMS Integration"
            />
          </Grid>

          {chatbotSettings && chatbotSettings?.omsEnabled && (
            <>
              <Grid item xs={12}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Query message when OMS id not passed to chatbot
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value={chatbotSettings.omsQuery}
                    onChange={(e) => handleChange(e, "omsQuery")}
                    id="title-input"
                    label="title"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Response message to be displayed after OMS query
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value={chatbotSettings.omsResponse}
                    onChange={(e) => handleChange(e, "omsResponse")}
                    id="title-input"
                    label="title"
                  />
                </FormControl>
              </Grid>
            </>
          )}
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ mt: 2 }}>
            <Typography className="title">
              Bot image :{" "}
              <span className="title-tooltip">
                (Image size must be less than 1 MB.) (Maximum image dimension
                should be 300 x 200 in png/jpg/jpeg format)
              </span>
              <div style={{ display: "inline-block", color: "red" }}>*</div>
            </Typography>
            <Box className="upload-wrap" sx={{ display: "flex" }}>
              {!chatbotSettings?.chatbotIcon && (
                <Button
                  variant="outlined"
                  component="label"
                  className="upload-btn"
                  // onChange={(e: any) => setSelectedImage(e.target.files[0])}
                >
                  <i className="icon-upload" />
                  <div>Upload Icon</div>
                  <div style={{ marginTop: "15px" }}> Image</div>
                  <input
                    hidden
                    accept=".png, .jpg, .jpeg"
                    onClick={(event) => handleChangeEvent(event)}
                    onChange={(e) => handleImageChange(e, "chatbotIcon")}
                    type="file"
                  />
                </Button>
              )}

              {chatbotSettings.chatbotIcon && (
                <Box className="img-preview">
                  {/* <img src={chatbotSettings.chatbotIcon} /> */}
                  <img id="svgImage" src={svgContent} />
                </Box>
              )}

              {chatbotSettings.chatbotIcon && (
                <Tooltip title="Delete Image" placement="top">
                  <i
                    className="icon-delete cursor-pointer"
                    onClick={() =>
                      deleteImage(chatbotSettings?.chatbotIcon, "chatbotIcon")
                    }
                  />
                </Tooltip>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ mt: 2 }}>
            <Typography className="title">
              Send Button Image :{" "}
              <span className="title-tooltip">
                (Image size must be less than 1 MB.) (Maximum image dimension
                should be 300 x 200 in png/jpg/jpeg format)
              </span>
              <div style={{ display: "inline-block", color: "red" }}>*</div>
            </Typography>
            <Box className="upload-wrap" sx={{ display: "flex" }}>
              {!chatbotSettings.sendIcon && (
                <Button
                  variant="outlined"
                  component="label"
                  className="upload-btn"
                  // onChange={(e: any) => setSelectedImage(e.target.files[0])}
                >
                  <i className="icon-upload" />
                  <div>Upload Icon</div>
                  <div style={{ marginTop: "15px" }}> Image</div>
                  <input
                    hidden
                    accept=".png, .jpg, .jpeg"
                    onClick={(event) => handleChangeEvent(event)}
                    onChange={(e) => handleImageChange(e, "sendIcon")}
                    type="file"
                  />
                </Button>
              )}

              {chatbotSettings.sendIcon && (
                <Box className="img-preview">
                  {/* <img src={chatbotSettings.sendIcon} /> */}
                  <img id="svgImage" src={svgsendIconContent} />
                </Box>
              )}

              {chatbotSettings.sendIcon && (
                <Tooltip title="Delete Image" placement="top">
                  <i
                    className="icon-delete cursor-pointer"
                    onClick={() =>
                      deleteImage(chatbotSettings?.sendIcon, "sendIcon")
                    }
                  />
                </Tooltip>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ mt: 2 }}>
            <Typography className="title">
              Bottom Chat Button Image :{" "}
              <span className="title-tooltip">
                (Image size must be less than 1 MB.) (Maximum image dimension
                should be 300 x 200 in png/jpg/jpeg format)
              </span>
              <div style={{ display: "inline-block", color: "red" }}>*</div>
            </Typography>
            <Box className="upload-wrap" sx={{ display: "flex" }}>
              {!chatbotSettings.chatIcon && (
                <Button
                  variant="outlined"
                  component="label"
                  className="upload-btn"
                >
                  <i className="icon-upload" />
                  <div>Upload Icon</div>
                  <div style={{ marginTop: "15px" }}> Image</div>
                  <input
                    hidden
                    accept=".png, .jpg, .jpeg"
                    onClick={(event) => handleChangeEvent(event)}
                    onChange={(e) => handleImageChange(e, "chatIcon")}
                    type="file"
                  />
                </Button>
              )}

              {chatbotSettings.chatIcon && (
                <Box className="img-preview">
                  {/* <img src={chatbotSettings.chatIcon} /> */}
                  <img id="svgImage" src={svgchatIconContent} />
                </Box>
              )}

              {chatbotSettings.chatIcon && (
                <Tooltip title="Delete Image" placement="top">
                  <i
                    className="icon-delete cursor-pointer"
                    onClick={() =>
                      deleteImage(chatbotSettings.chatIcon, "chatIcon")
                    }
                  />
                </Tooltip>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          sx={{ mt: 2, p: 0, mb: 0, lineHeight: 0 }}
          xs={12}
          md={12}
          className="acc-prod-footer"
        >
          <Tooltip title="Go to AI Settings" placement="bottom">
            <Button
              size="small"
              className="backbtn"
              onClick={(e: any) => {
                handleAccordianChange(true, "AISettings", "back");
              }}
            >
              {" "}
              &nbsp;
              <KeyboardArrowLeft />
              <span className="acc-prod-prev-span">Previous :</span>&nbsp;{" "}
              <span>Go to AI Settings</span>
            </Button>
          </Tooltip>
          <Tooltip title="Go to Theme and Branding" placement="bottom">
            <Button
              size="small"
              className="nextbtn guideTourChatThemeBrandngSettings"
              onClick={(e: any) => {
                handleAccordianChange(true, "chatbotAppearance", "next");
              }}
            >
              &nbsp;<span className="acc-prod-next-span">Next :</span>&nbsp;{" "}
              <span>Go to Theme and Branding</span>
              <KeyboardArrowRight />
            </Button>
          </Tooltip>{" "}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default withSnackbar(GeneralSettings);
